(function () {
  function initArboraHeroSlideshows(scope) {
    const root = scope || document;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const slideshows = root.querySelectorAll('[data-arbora-hero-slideshow]');

    slideshows.forEach(function (slideshow) {
      if (slideshow.dataset.arboraHeroReady === 'true') return;

      const slides = Array.from(slideshow.querySelectorAll('.arbora-hero-slide'));
      if (!slides.length) return;

      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === 0);
      });

      if (slides.length < 2 || prefersReducedMotion) return;

      slideshow.dataset.arboraHeroReady = 'true';
      slideshow.classList.add('is-ready');

      let index = 0;
      const speed = Math.max(parseInt(slideshow.dataset.arboraSlideSpeed, 10) || 5000, 2500);

      window.setInterval(function () {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, speed);
    });
  }

  function initArboraMotion() {
    initArboraHeroSlideshows(document);

    if (document.documentElement.dataset.arboraMotionReady === 'true') return;
    document.documentElement.dataset.arboraMotionReady = 'true';

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.documentElement.classList.add('arbora-reveal-ready');

    const revealTargets = document.querySelectorAll(
      [
        '.arbora-editorial',
        '.arbora-collections',
        '.arbora-story',
        '.arbora-banner',
        '.section-resource-list__content',
        '.product-grid-container',
        '.resource-list__item',
        '.product-grid__item'
      ].join(',')
    );

    revealTargets.forEach(function (target, index) {
      target.setAttribute('data-arbora-reveal', '');
      target.style.setProperty('--arbora-reveal-delay', Math.min(index % 5, 4) * 70 + 'ms');
    });

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealTargets.forEach(function (target) {
        target.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    revealTargets.forEach(function (target) {
      observer.observe(target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArboraMotion, { once: true });
  } else {
    initArboraMotion();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initArboraHeroSlideshows(event.target);
  });
})();
